import { useEffect, useRef, useCallback } from "react";

const IS_OFFLINE = process.env.REACT_APP_MODE_OFFLINE === "true";
const INACTIVITY_TIMEOUT_MS = 3 * 60 * 60 * 1000; // 3 hours

const useInactivityLogout = ({ isAuthenticated, logout }) => {
  const timerRef = useRef(null);
  const lastMouseMove = useRef({ x: 0, y: 0 });
  const lastResetTime = useRef(Date.now());

  const resetTimer = useCallback((e) => {
    const now = Date.now();

    if (e.type === "mousemove") {
      const deltaX = Math.abs(e.clientX - lastMouseMove.current.x);
      const deltaY = Math.abs(e.clientY - lastMouseMove.current.y);
      const deltaT = now - lastResetTime.current;

      if (deltaX < 5 && deltaY < 5 && deltaT < 1000) return;

      lastMouseMove.current = { x: e.clientX, y: e.clientY };
    }

    lastResetTime.current = now;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, INACTIVITY_TIMEOUT_MS);
  }, [logout]);

  useEffect(() => {
    // In offline mode suppress this feature
    if (IS_OFFLINE || !isAuthenticated) return;

    timerRef.current = setTimeout(logout, INACTIVITY_TIMEOUT_MS);

    const activityEvents = [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "scroll"
    ];

    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    return () => {
      clearTimeout(timerRef.current);
      activityEvents.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [isAuthenticated, logout, resetTimer]);

  // Optional: log when the tab is focused or blurred
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "hidden") {
  //       // TO UNCOMMENT TOKEN AUTH: Uncomment below for visibility log
  //       console.log("🔒 Tab hidden — pausing activity checks");
  //     } else {
  //       console.log("🔓 Tab focused — resuming");
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  // }, []);
};

export default useInactivityLogout;
